module.exports = __webpack_public_path__ + "images/xyz1-7c598d2891c04d6ca8141de471d80385.jpg";